/**
 * Strips HTML tags from a string
 * @param html String containing HTML markup
 * @returns String with HTML tags removed
 */
export function stripHtml(html: string): string {
  if (!html) return '';
  // Create a temporary div element
  const tmp = document.createElement('div');
  // Set the HTML content
  tmp.innerHTML = html;
  // Return the text content only (strips HTML tags)
  return tmp.textContent || tmp.innerText || '';
}
